export enum PageTypePortal {
  Home = "/portal/auth/sign-in",
  Login = "/portal/auth/sign-in",
  ResetPassword = "/portal/auth/reset-password",
  ForgotPassword = "/portal/auth/forgot-password",
  Dashboard = "/portal/dashboard",
  Dashboard3 = "/portal/dashboard-3",
  Balance = "/portal/dashboard/balance",
  ProfileSettings = "/portal/dashboard/profile-settings",
  ClassRegistration = "/portal/dashboard/class-registration",
  Contact = "/portal/dashboard/contact",
  Terms = "/portal/dashboard/terms",
  SignUp = "/portal/auth/sign-up",
  EditFamilyContact = "/portal/dashboard/profile-settings/edit-family-contact",
  AddFamilyContact = "/portal/dashboard/profile-settings/add-family-contact",
  Students = "/portal/dashboard/students",
  Appointments = "/portal/dashboard/appointments",
  Notifications = "/portal/dashboard/notifications",
  Makeups = "/portal/dashboard/makeups",
  GetStarted = "/portal/dashboard/get-started",
  Resources = "/portal/dashboard/resources",
}

export enum PageTypeGlobal {
  Home = "/",
  Classes = "/classes",
  Teachers = "/teachers",
  Locations = "/locations",
  Contact = "/contact",
  Terms = "/terms",
  Tickets = "/tickets",
}

export enum PageTypeAdmin {
  Home = "/admin",
  SignIn = "/admin/auth/sign-in",
  ForgotPassword = "/admin/auth/forgot-password",
  ResetPassword = "/admin/auth/reset-password",
  Dashboard = "/admin/dashboard",
  Students = "/admin/dashboard/students",
  Parents = "/admin/dashboard/parents",
  Teachers = "/admin/dashboard/teachers",
  Employees = "/admin/dashboard/employees",
  Contractors = "/admin/dashboard/contractors",
  Dances = "/admin/dashboard/dances",
  Appointments = "/admin/dashboard/appointments",
  Classes = "/admin/dashboard/classes",
  Facilities = "/admin/dashboard/facilities",
  Locations = "/admin/dashboard/locations",
  Seasons = "/admin/dashboard/seasons",
  ClassRooms = "/admin/dashboard/class-rooms",
  Policies = "/admin/dashboard/policies",
  Settings = "/admin/dashboard/settings",
  Plugins = "/admin/dashboard/plugins",
  Balance = "/admin/dashboard/balance",
  Tuition = "/admin/dashboard/tuition",
  Invoices = "/admin/dashboard/invoices",
  /** @deprecated Legacy path; redirects to Invoices. */
  Charge = "/admin/dashboard/charge",
  Jobs = "/admin/dashboard/jobs",
  Reports = "/admin/dashboard/reports",
  PendingEnrollments = "/admin/dashboard/enrollments/pending",
  WaitlistEnrollments = "/admin/dashboard/enrollments/waitlist",
  ParentEnrollmentFollowUp = "/admin/dashboard/enrollments/parent-follow-up",
  WithdrawalRequests = "/admin/dashboard/enrollments/withdrawals",
  MakeupRequests = "/admin/dashboard/makeups",
  Notifications = "/admin/dashboard/notifications",
  Tasks = "/admin/dashboard/tasks",
  TimeClock = "/admin/dashboard/time-clock",
  Tickets = "/admin/dashboard/tickets",
  TicketScan = "/admin/dashboard/tickets/scan",
  // Teacher-only paths (teacher sidebar and guard)
  Availability = "/admin/dashboard/availability",
  PayrollHours = "/admin/dashboard/payroll-hours",
  Attendance = "/admin/dashboard/attendance",
  Resources = "/admin/dashboard/resources",
  Password = "/admin/dashboard/password",
}
